export const ENTER = "Enter";
export const ENTER_TEST_VAL = { key: "Enter", code: "Enter", charCode: 13 };
export const DOWN = "Down";
export const DOWN_TEST_VAL = { key: "Down", code: "Down", charCode: 40 };
export const ARROW_DOWN = "ArrowDown";
export const UP = "Up";
export const UP_TEST_VAL = { key: "Up", code: "Up", charCode: 38 };
export const ARROW_UP = "ArrowUp";
export const TAB = "Tab";
export const TAB_TEST_VAL = { key: "Tab", code: "Tab", charCode: 9 };
export const SHIFT_TAB_TEST_VAL = {
  key: "Tab",
  code: "Tab",
  charCode: 9,
  shiftKey: true
};
export const SPACE = "(space)";

/** A keyboard event from either React or the DOM. */
export type KeyLikeEvent = {
  key: string;
  shiftKey?: boolean;
  preventDefault?: () => void;
};

export const handleEnterKeypress = <E extends KeyLikeEvent>(
  event: E,
  callback: (event: E) => void
) => {
  const key = event.key;
  if (key === ENTER) {
    callback(event);
  }
};

export const handleDownKeypress = <E extends KeyLikeEvent>(
  event: E,
  callback: (event: E) => void
) => {
  const key = event.key;
  if (key === DOWN || key === ARROW_DOWN) {
    callback(event);
  }
};

export const handleUpKeypress = <E extends KeyLikeEvent>(
  event: E,
  callback: (event: E) => void
) => {
  const key = event.key;
  if (key === UP || key === ARROW_UP) {
    callback(event);
  }
};

export const handleTabKeypress = <E extends KeyLikeEvent>(
  event: E,
  callback: (event: E) => void
) => {
  const key = event.key;
  if (key === TAB) {
    callback(event);
  }
};

export const handleSpaceKeypress = <E extends KeyLikeEvent>(
  event: E,
  callback: (event: E) => void
) => {
  const key = event.key;
  if (key === SPACE) {
    callback(event);
  }
};

export const handleShiftTabKeypress = <E extends KeyLikeEvent>(
  event: E,
  callback: (event: E) => void
) => {
  const key = event.key;
  if (event.shiftKey && key === TAB) {
    callback(event);
  }
};
